module.exports = __webpack_public_path__ + "img/phone.a6dc4e19.png";